module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.c2705c5e.png";